import { render, staticRenderFns } from "./ViewsByPage.vue?vue&type=template&id=06e1b1aa&"
import script from "./ViewsByPage.vue?vue&type=script&lang=js&"
export * from "./ViewsByPage.vue?vue&type=script&lang=js&"
import style0 from "./ViewsByPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports